// extracted by mini-css-extract-plugin
module.exports = {"fieldWrapper":"FormValue_fieldWrapper__f0k06","label":"FormValue_label__pcSEA"};